import { useState, useEffect } from 'react';

import { Link, NavLink } from "react-router-dom";

import classNames from 'classnames';

import { localizationService, getText } from '../../services/localization.js';

import styles from './Header.module.css';

export const Header = () => {

  const [toggleMenu, setToggleMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth <= 992);

    window.addEventListener('resize', () => {
      setIsMobile(window.innerWidth <= 992)
    })
  }, []);

  const activeStyle1 = {
    color: 'red',
    fontWeight: 'bold'
  }

  return (
    <nav
      className={classNames(styles.headerWrapper, {
        [styles.arabicStyle]: localizationService.currentLang$.value === 'AR',
      })}>
      <div className="container">
        <div className={styles.header}>
          <div className="logo">
            <Link to="/"><img className={styles.logo} src='https://storage.googleapis.com/door-assets/site/others/logo.jpg' alt="logo" /></Link>
          </div>
          <div
            className={styles.toggleIcon}
            onClick={() => setToggleMenu(!toggleMenu)}
          >
            { (isMobile && toggleMenu) && <div className={styles.closeIcon}>&#10005;</div> }
            { (isMobile && !toggleMenu) && <div className={styles.hamburger}></div> }
          </div>
          <div className={`${styles.menu} ${(isMobile && !toggleMenu) ? styles.menuActive : ''}`}>
            <ul className={styles.menuList}>
              <li className={styles.menuItem}><NavLink to="/">{getText('الرئسية', 'Home')}</NavLink></li>
              <li className={styles.menuItem}>
                <span>{getText('منتجاتنا', 'Our Products')}</span>
                <ul className={styles.subMenu}>
                  <div className={styles.groupItems}>
                    <li className={styles.mainItem}><Link to="/product?type=security">{getText('أبواب', 'Doors')}</Link></li>
                    {/* <li className={styles.subItem}><Link to="/product?type=indoor">{getText('أبواب داخلية', 'In Door')}</Link></li>
                    <li className={styles.subItem}><Link to="/product?type=security">{getText('أبواب امان', 'Security Doors')}</Link></li> */}
                  </div>
                  <div className={styles.groupItems}>
                    <li className={styles.mainItem}><Link to="/product?type=steel_work">{getText('اعمال حديد', 'Steel Work')}</Link></li>
                  </div>
                  <div className={styles.groupItems}>
                    <li className={styles.mainItem}><Link to="/product?type=kitchens">{getText('مطابخ', 'Kitchens')}</Link></li>
                  </div>
                  <div className={styles.groupItems}>
                    <li className={styles.mainItem}><Link to="/product?type=bedrooms">{getText('غرف نوم', 'Bedrooms')}</Link></li>
                  </div>
                </ul>
              </li>
              <li className={styles.menuItem}><Link to="/new-items">{getText('منتجات جديدة', 'New Products')}</Link></li>
              <li className={styles.menuItem}><Link to="/about">{getText('عن الشركة', 'Company Profile')}</Link></li>
              <li className={styles.menuItem}><Link to="/contact-us">{getText('اتصل بنا', 'Contact Us')}</Link></li>
              <li
                className={`${styles.menuItem} ${styles.arabicMenu}`}
                onClick={() => localizationService.currentLang$.next(localizationService.currentLang$.value === 'EN' ? 'AR' : 'EN')}
              >
                {getText('EN', 'عربي')}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  )
}
